import React from 'react';
import styled from '@emotion/styled';

import HandOffLink from '../../../utils/urls/HandOffLink';

import { isLoggedIn, accountId } from '../../../utils/selectors/account';
import withTrackingPropsProvider from '../../../hocs/withTrackingPropsProvider';

import colors from '../../../styling/colors';

const ActionsList = styled.div`
  width: 100%;
  padding: 0 10px;
`;

const ActionLink = styled(HandOffLink)`
  display: block;
  font-size: 0.875rem;
  line-height: 1.875rem;
  color: ${colors('lapel')};
  text-decoration: none;

  :hover {
    color: ${colors('dustyGray')};
  }
`;

const TrackedActionsList = withTrackingPropsProvider(ActionsList);

const TRACKING_PROPS = {
  block_name: 'account_drawer',
  block_row: 'account_drawer',
};

export default function AccountActions(props) {
  const { account, logoutAction } = props;
  if (!isLoggedIn(account)) {
    return <ActionsList />;
  }

  return (
    <TrackedActionsList tracking={TRACKING_PROPS}>
      <ActionLink href="/buy_coins">Buy Coins</ActionLink>
      <ActionLink href="/dashboard">Dashboard</ActionLink>
      <ActionLink href="/postbox">Postbox</ActionLink>
      <ActionLink href="/postbox#/drafts">Drafts</ActionLink>
      <ActionLink href="/flyer/manage">My Flyers</ActionLink>
      <ActionLink href="/accounts/address_book">Address Book</ActionLink>
      <ActionLink href={'/accounts/' + accountId(account) + '/edit'}>
        Account Settings
      </ActionLink>
      <ActionLink href="/help">Help Center</ActionLink>
      <ActionLink href="#" preRedirects={[logoutAction]}>
        Log out
      </ActionLink>
    </TrackedActionsList>
  );
}
